import { render, staticRenderFns } from "./Replys.vue?vue&type=template&id=f11c909a&scoped=true&"
import script from "./Replys.vue?vue&type=script&lang=js&"
export * from "./Replys.vue?vue&type=script&lang=js&"
import style0 from "./Replys.vue?vue&type=style&index=0&id=f11c909a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c909a",
  null
  
)

export default component.exports